"use client";
import { cn, copyText, dayjs, formatPrettyValue } from "utils";
import React, { useMemo, useContext } from "react";
import { PageFooter } from "../Footer";
import { SuccessModal } from "./SuccessModal";
import { useConnect, useSeasonConfig, useSeasonDetail, useClaim, useIsPc } from "@/hooks";
import { claimStatusEum, settleStatusEum } from "@/const";
import { Spinner, Copy } from "../Icon";
import { PageHeader } from "../Header";
import { GlobalContext } from "@/context";
import { message } from "../Message";

export const HomeVerified = () => {
  const { loggingIn } = useContext(GlobalContext);
  const [isPc] = useIsPc();
  const { onConnect, onDisconnect, address, loading } = useConnect();
  const { seasonConfig, isConfigLoading } = useSeasonConfig();
  const { id, settleStatus: curSettleStatus } = seasonConfig || {};
  let curSeasonId = id - 1;
  if(curSettleStatus !== 0) {
    curSeasonId = id;
  }
  const { achievementDetail, isFetching, refetch } = useSeasonDetail({seasonId: curSeasonId});
  const { settleStatus, claimStatus, owoCount, claimEndTime, claimStartTime, endTime, connectWallet } = achievementDetail || {};
  const { onClaim: onClaimButter, hash, claiming, isSuccess, setIsSuccess } = useClaim();
  const onClose = () => {
    setIsSuccess(false);
    refetch();
  }
  const claimOwoTextMap = {
    [claimStatusEum.CLAIMED]: "Claimed",
    [claimStatusEum.UN_CLAIMED]: "Claim $BUTTER",
    [claimStatusEum.UN_STARTED]: `Claim on ${dayjs(claimStartTime).utc().format("MMM D, HH:mm")} UTC`,
    [claimStatusEum.EXPIRED]: "Expired",
  } as any;

  const claimMessage = claimStatus === claimStatusEum.EXPIRED ? "Claim period ended" : `Claim before ${dayjs(claimEndTime).utc().format("MMM D, YYYY HH:mm:ss")} UTC`;

  const owoValue = useMemo(() => {
    const value = {
      0: '???????',
      1: 'Calculating…',
      2: formatPrettyValue(owoCount?.toString())
    } as any;
    const owoValue = value[settleStatus] || '0';
    return owoValue;
  }, [settleStatus]);
  const onClaim = async () => {
    
    await onClaimButter(seasonConfig?.owoTokenAddress)
  }
  const copy= () => {
    copyText(location.href)
    setTimeout(() => {
      message({
        content:'copy success!',
        className:'message-default'
      })
    }, 500)
  }
  
  return (
    <>
      <div className={cn("h-screen w-screen bg-Overlay-Dark-Overlay80/20 backdrop-blur-[30px] pt-6 flex flex-col items-center z-20 fixed top-0", {
        "hidden": isPc
      })}>
        <div className={cn(
          "w-[160px] mb-[115px]"
        )}>
          <img
            src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/bread-butter-logo.svg`}
            alt="bread-butter"
          />
        </div>
        <div className="w-20 h-20 m-4">
          <img
            src={`${process.env.NEXT_PUBLIC_BASE_PATH}/assets/computer.svg`}
            alt="computer"
          />
        </div>
        <div className="text-Content-Primary text-2xl font-oswald font-bold mb-6">Desktop Viewing Only</div>
        <div className="text-Content-Secondary text-base font-oswald max-w-[280px] text-center">This page is optimized for desktop viewing. Please copy the link and access our page using a desktop device for the best experience.</div>
        <button className="btn-lg btn-fill-black rounded-[20px] min-w-[360px] text-Content-Inverse-Primary absolute bottom-[44px]" onClick={copy}><Copy className="fill-Content-Inverse-Primary w-5 h-5"/> Copy Link</button>
      </div>
      <PageHeader className={cn('fixed z-[10] w-screen')} onConnect={onConnect} onDisconnect={onDisconnect} loading={loading} address={address as `0x${string}`}/>
      <div
        className={cn("h-full pb-[288px] relative", {
          "overflow-hidden": !isPc
        })}
      >
        <div className="relative bg-no-repeat bg-[url('/assets/airdropBg.webp')] bg-cover bg-[center_bottom_0] h-[517px]">
          <div className="absolute -bottom-[40px] left-[50%] -translate-x-2/4 bg-[url('/assets/airdropDate.webp')] bg-no-repeat bg-cover w-[660px] h-[447px] flex items-center flex-col pt-[190px] pl-8">
            <p className="text-sm text-Content-Primary font-oswald font-bold h-[21px]">{!!curSeasonId ? `· Season ${curSeasonId} ·`: ''}</p>
            <div className="text-4xl font-luckiestGuy font-bold mb-1 text-center">$butter airdrop</div>
            <div className="px-3 pt-2 bg-Content-Primary rounded-[6px] text-Primitives-Yellow-500 font-luckiestGuy text-[44px] leading-[52px] overflow-hidden mb-1 min-w-[124px] text-center">{loggingIn ? owoValue : '???????'}</div>
            <p className="text-xs text-Content-Primary font-oswald font-bold">{
              !!achievementDetail && !!loggingIn ? (settleStatus !== settleStatusEum.SETTLED ? `Results on ${dayjs(endTime).utc().format("MMM D, YYYY HH:mm:ss")}UTC` : claimMessage)  : "" }</p>
          </div>
        </div>
        <div className="flex-col flex items-center mt-[40px]">
          <p className="text-base text-Accent-Inverse-Backup3 font-bold font-oswald">$BUTTER will be sent on BNB Chain</p>
          <p className="text-base text-Accent-Inverse-Backup3 font-oswald text-center">To claim $BUTTER, connect the wallet with the same address linked to your BreadnButter account.</p>
          {loggingIn ? <button className={cn("btn-lg font-oswald btn-fill-green font-bold rounded-[20px] min-w-[360px] my-6", {
            "btn-fill-gray cursor-not-allowed text-Content-Disabled" : claimStatus !== claimStatusEum.UN_CLAIMED || !connectWallet,
          })} onClick={onClaim} disabled={claimStatus !== claimStatusEum.UN_CLAIMED || isFetching || isConfigLoading || loading || claiming || !connectWallet}>
            {isFetching || isConfigLoading || loading || claiming ? (
              <Spinner
                className={cn("fill-Content-Primary w-5 h-5 animate-spin")}
              />
            ) : (
              !!connectWallet ? claimOwoTextMap[claimStatus] || 'Claim $BUTTER' : "Unable to claim"
            )}
          </button> : <button className={cn("btn-lg font-oswald btn-fill-green font-bold rounded-[20px] min-w-[360px] my-6")} onClick={onConnect}>
                {isFetching || isConfigLoading || loading ? (
                  <Spinner
                    className={cn("fill-Content-Primary w-5 h-5 animate-spin")}
                  />
                ) : 'Claim $BUTTER'}
              </button>}
        </div>
        <PageFooter className='w-screen absolute bottom-0'/>
        <SuccessModal visible={isSuccess} close={onClose} hash={hash as string}/>
      </div>
    </>
  );
};

